import { render, staticRenderFns } from "./my_collection.vue?vue&type=template&id=b44a5c46&scoped=true"
import script from "./my_collection.vue?vue&type=script&lang=js"
export * from "./my_collection.vue?vue&type=script&lang=js"
import style0 from "./my_collection.vue?vue&type=style&index=0&id=b44a5c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44a5c46",
  null
  
)

export default component.exports